module.exports = __webpack_public_path__ + "static/media/025-boy-4.f870ed39.svg";